// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin (webpack.config.js)
import StyledLoginForm from "./StyledLoginForm-APP_CLIENT.styled";

export default StyledLoginForm;
